
import layoutMixin from "@/mixins/layout"

export default layoutMixin.extend({})
